<template>
  <div class="message-freestyle">

    <div class="message message-freestyle__signup m-b-10"
        :title="datetime"
        :class="{patient: fromPatient}">

      <div class="message-freestyle-signup__content">
        <text-string label-id="txt1464"/>
        <text-string label-id="txt1465"/>

        <div class="image-container">
          <img src="@/assets/images/program/freestylelibre/006_old.png"/>
          <smd-btn class="message-freestyle-signup__btn"
                  section="1"
                  variant="blue-enabled"
                  @click="onBtnClick">
            <text-string label-id="txt1447"/>
          </smd-btn>
        </div>
      </div>

      <p class="Label1 gray-400 m-t-5">{{ formattedTime }}</p>
    </div>

    <div class="message-prescription"
        :title="datetime"
        :class="{patient: fromPatient}">

      <div class="message-files__not-image">
        <p class="label-6 m-b-5">Sent a Prescription.</p>

        <div class="smd-panel smd-form__row m-b-10"
            @click="viewFile">
          <span class="file-icon ns-icon-ico012"/>
          <p class="file-name">Prescription</p>
        </div>

        <p class="Label1 gray-400">{{ formattedTime }}</p>
      </div>

    </div>
  </div>
</template>

<script>
  import Routes from "@/router/routes";
  import {mapGetters} from 'vuex';
  import {mapFields} from 'vuex-map-fields';
  import {toPhilMoment} from '@/utils/dates';
  import {isFSLEProgramId} from '@/reference/coupon';
  import PreviewFileType from "@/reference/preview-file-type";
  import {GETTER_DOCTOR_PATIENT_PARTNER} from "@/store/types";
  import TitleMixin from '@/mixins/title-mixin';

  export default {
    name: 'message-freestyle-signup-prescription',
    mixins: [
      TitleMixin,
    ],
    props: {
      message: {type: Object, required: true},
      token: {type: String, required: true},
      fromPatient: {type: Boolean, required: true},
    },
    computed: {
      ...mapFields('program', {
        programCoupon: 'coupon',
        uploadid: 'uploadid',
      }),
      ...mapGetters({
        doctorPatientPartner: GETTER_DOCTOR_PATIENT_PARTNER,
      }),
      formattedTime() {
        return toPhilMoment(this.message.received).format('hh:mm a');
      },
      datetime() {
        return toPhilMoment(this.message.received).format('MMMM D, YYYY hh:mm a');
      },
    },
    methods: {
      onBtnClick() {
        if (isFSLEProgramId(this.message.coupons[0].programid)) {
          this.programCoupon = this.message.coupons[0];
          this.uploadid = this.message.uploadid;
          this.$router.push({
            name: Routes.PROGRAM_ROOT,
          });
          return;
        }
      },
      viewFile() {
        const {doctor} = this.doctorPatientPartner[this.token];
        const fileData = {
          ...this.message,
          token: this.token,
          doctorname: doctor._fullName,
          coupons: [], //no coupons attached ni FSLE if used as normal pharmacy order
        };

        this.$router.push(
          {
            name: Routes.PREVIEW_FILE,
            params: {
              file: [fileData],
              title: this.computedTitle(fileData),
              filesView: true,
              type: PreviewFileType.PREVIEW_TYPE_PRESCRIPTION
            },
          }
        )
      },
    },
  }
</script>

<style lang="scss" scoped>
  .message {
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);

    .time {
      font-size: font(s);
    }
  }

  .patient {
    background-color: color(blue, brand);

    p {
      color: color(white, text) !important;
      word-break: break-word;
    }

    .time {
      text-align: right;
    }
  }

  .image-container {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .message-freestyle-signup__btn {
    background-color:#001489;
    border-radius: 0px !important;
  }
</style>
